var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHeader),expression:"showHeader"}],staticClass:"head ljb-border"},[_c('span',{class:{back:!_vm.BackArrow},on:{"click":_vm.back}}),_vm._v("\n  "+_vm._s(_vm.title)+"\n"),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-dbf2c874","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/LjbHeader.vue
// module id = null
// module chunks = 